<template>
    <div class="d-flex flex-wrap gap-2 mb-3">
      <!-- Fetch Status Chips -->
      <v-chip
        v-if="fetchStatusCounts[UrlFetchStatus.NOT_FETCHED] > 0"
        :color="activeFetchStatusFilters.includes(UrlFetchStatus.NOT_FETCHED) ? 'primary' : 'grey lighten-1'"
        outlined
        clickable
        @click="toggleFetchStatusFilter(UrlFetchStatus.NOT_FETCHED)"
      >
        Not Fetched ({{ fetchStatusCounts[UrlFetchStatus.NOT_FETCHED] }})
      </v-chip>
      <v-chip
        v-if="fetchStatusCounts[UrlFetchStatus.TO_FETCH] > 0"
        :color="activeFetchStatusFilters.includes(UrlFetchStatus.TO_FETCH) ? 'primary' : 'grey lighten-1'"
        outlined
        clickable
        @click="toggleFetchStatusFilter(UrlFetchStatus.TO_FETCH)"
      >
        To Fetch ({{ fetchStatusCounts[UrlFetchStatus.TO_FETCH] }})
      </v-chip>
      <v-chip
        v-if="fetchStatusCounts[UrlFetchStatus.FETCHED] > 0"
        :color="activeFetchStatusFilters.includes(UrlFetchStatus.FETCHED) ? 'primary' : 'grey lighten-1'"
        outlined
        clickable
        @click="toggleFetchStatusFilter(UrlFetchStatus.FETCHED)"
      >
        Fetched ({{ fetchStatusCounts[UrlFetchStatus.FETCHED] }})
      </v-chip>
      <v-chip
      v-if="fetchStatusCounts[UrlFetchStatus.FAILED] > 0"
      :color="activeFetchStatusFilters.includes(UrlFetchStatus.FAILED) ? 'primary' : 'grey lighten-1'"
      outlined
      clickable
      @click="toggleFetchStatusFilter(UrlFetchStatus.FAILED)"
    >
      Failed ({{ fetchStatusCounts[UrlFetchStatus.FAILED] }})
    </v-chip>
    
      <!-- Optional Sitemap Chips -->
      <template v-if="showSitemapFilters">
        <v-chip
          v-if="sitemapCount > 0"
          :color="activeSitemapFilters.includes(true) ? 'primary' : 'grey lighten-1'"
          outlined
          clickable
          @click="toggleSitemapFilter(true)"
        >
          Sitemap ({{ sitemapCount }})
        </v-chip>
        <v-chip
          v-if="nonSitemapCount > 0"
          :color="activeSitemapFilters.includes(false) ? 'primary' : 'grey lighten-1'"
          outlined
          clickable
          @click="toggleSitemapFilter(false)"
        >
          Not Sitemap ({{ nonSitemapCount }})
        </v-chip>
      </template>
    </div>
  </template>
  
  <script setup lang="ts">
  import UrlFetchStatus from '@/enums/UrlFetchStatus';
  
  withDefaults(defineProps<{
    fetchStatusCounts: Record<UrlFetchStatus, number>;
    activeFetchStatusFilters: UrlFetchStatus[];
    toggleFetchStatusFilter: (status: UrlFetchStatus) => void;
    // Optional sitemap filtering props.
    showSitemapFilters?: boolean;
    sitemapCount?: number;
    nonSitemapCount?: number;
    activeSitemapFilters?: boolean[];
    toggleSitemapFilter?: (value: boolean) => void;
  }>(), {
    showSitemapFilters: false,
    sitemapCount: 0,
    nonSitemapCount: 0,
    activeSitemapFilters: () => [],
    // Provide a no-op default function if not provided.
    toggleSitemapFilter: () => {},
  });
  </script>
  